<template>
  <div>
    <v-card class="card" link to="/menu/al/sandwich">
      <v-card-title>Sanduiç</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/al/toast">
      <v-card-title>Tost</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/al/pizza">
      <v-card-title>Pizza</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/al/salads">
      <v-card-title>Sallatë</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/al/beverage">
      <v-card-title>Pijeve</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/al/sides">
      <v-card-title>Shtesë</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/al/icecream">
      <v-card-title>Akullore</v-card-title>
    </v-card>
    
  </div>
</template>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 1.2rem auto;
  max-width: 18rem;
  text-align: center;
}
.button {
  background-color: #dc143c;
  color: white;
  max-width: 100px;
}
</style>
<script setup>
</script>